/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Card_Unpaid_HintInputs */

const en_admin_funnel_card_unpaid_hint = /** @type {(inputs: Admin_Funnel_Card_Unpaid_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users who reached a payment page in the last 24h and have not paid since.`)
};

/**
* | output |
* | --- |
* | "Users who reached a payment page in the last 24h and have not paid since." |
*
* @param {Admin_Funnel_Card_Unpaid_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_card_unpaid_hint = /** @type {((inputs?: Admin_Funnel_Card_Unpaid_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Card_Unpaid_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_card_unpaid_hint(inputs)
});
export { admin_funnel_card_unpaid_hint as "admin.funnel.card.unpaid_hint" }